// extracted by mini-css-extract-plugin
export default {"footer":"Modal_footer__sB1jh","header":"Modal_header__vx40T"};